import { PaymentDetailsModel, ProductDetailsModel } from '@app/core/Models';
import { Guid } from 'guid-typescript';

export class DebitNoteModel {
  id: Guid;
  entryNumber: string;
  accountId: Guid;
  bookAccountId?: Guid;
  fundId: Guid;
  entryDate?: string;
  currencyId: number;
  note: string;
  voucherNumber: string;
  attachment: Array<string>;
  debitNoteItems: Array<ProductDetailsModel>;
  invoiceAllocations: Array<PaymentDetailsModel>;
  receiptDetails: Array<any>;
  transactionLogId?: Guid;
  isManualBank?: boolean;
  isVatIncluded: boolean;
}
